import { useQueries } from '@tanstack/react-query';
import { API_PATIENT_KEY_NOTE } from 'services/dataService/resources';
import { ModuleType } from 'infrastructure/enums';

import { getKeyNotesHistory } from './api/getKeyNoteHistoryFn';

interface Props {
  patientGuid: string;
  module: ModuleType;
  canChangeModule?: boolean;
  noteGuid: string;
  historyGuid: string;
}
export const getKeyNoteHistoryKey = ({
  patientGuid,
  module,
  noteGuid,
  historyGuid,
}: Props) => [
  'getKeyNoteHistoryData',
  patientGuid,
  module,
  noteGuid,
  historyGuid,
];

export const useGetKeyNoteHistory = ({
  patientGuid,
  module,
  noteGuid,
  historyGuid,
}: Props) => {
  const apiUrl = API_PATIENT_KEY_NOTE(patientGuid);

  const [rpmQueryData, ccmQueryData] = useQueries({
    queries: [
      {
        queryKey: getKeyNoteHistoryKey({
          patientGuid,
          module: ModuleType.RPM,
          noteGuid,
          historyGuid,
        }),
        queryFn: () =>
          getKeyNotesHistory({
            url: `${apiUrl}/history?module=${ModuleType.RPM}&noteGuid=${noteGuid}&historyGuid=${historyGuid}`,
          }),
        enabled:
          module === ModuleType.RPM &&
          Boolean(historyGuid) &&
          Boolean(noteGuid) &&
          noteGuid !== historyGuid,
      },
      {
        queryKey: getKeyNoteHistoryKey({
          patientGuid,
          module: ModuleType.CCM,
          noteGuid,
          historyGuid,
        }),
        queryFn: () =>
          getKeyNotesHistory({
            url: `${apiUrl}/history?module=${ModuleType.CCM}&noteGuid=${noteGuid}&historyGuid=${historyGuid}`,
          }),
        enabled:
          module === ModuleType.CCM &&
          Boolean(historyGuid) &&
          Boolean(noteGuid) &&
          noteGuid !== historyGuid,
      },
    ],
  });
  return [rpmQueryData, ccmQueryData];
};
